/* istanbul ignore file */
export { default } from './NoVehicleIdCard';
